import { LOTTO_CONSTANTS } from '../constants';
import { createAssistantMessage, makeA2UIMessage } from './messageFactory';

export const createQuickPickHandler = (appendMessage) => async (
  options = {}
) => {
  const stake = options.stake ?? LOTTO_CONSTANTS.DEFAULT_STAKE;

  const message = createAssistantMessage(
    '',
    makeA2UIMessage('quick_pick', {
      stake,
      country: options.country,
      lottery_name: options.lotteryName,
      format: options.format,
    })
  );

  appendMessage(message);
};

export const createBrowseLotteriesHandler = (appendMessage, trackLottoEvent) => (
  options = {}
) => {
  trackLottoEvent('search_lotteries_opened');

  const message = createAssistantMessage(
    '',
    makeA2UIMessage('search_lotteries', {
      with_suggested_options: options.withSuggestedOptions ?? false,
      _timestamp: Date.now(),
    })
  );
  appendMessage(message);
};

export const createMyBetsHandler = (appendMessage) => () => {
  const assistantMessage = createAssistantMessage(
    '',
    makeA2UIMessage('my_bets', {})
  );
  appendMessage(assistantMessage);
};

export const createBettingOptionsRequestHandler = (
  metadata,
  appendMessage,
  trackLottoEvent
) => (lotteryId) => {
  metadata.stageLotteryId(lotteryId);
  trackLottoEvent('betting_options_opened', { lottery_id: lotteryId });

  const assistantMessage = createAssistantMessage(
    '',
    makeA2UIMessage('betting_options', { lottery_id: lotteryId })
  );

  appendMessage(assistantMessage);
};

export const createLottoResultsHandler = (appendMessage, trackLottoEvent) => () => {
  trackLottoEvent('lotteries_last_results_opened', {});
  const assistantMessage = createAssistantMessage(
    '',
    makeA2UIMessage('lotteries_last_results', { _timestamp: Date.now() })
  );
  appendMessage(assistantMessage);
};

export const createDetailedLotteryResultsHandler = (
  appendMessage,
  trackLottoEvent
) => (lotteryId, country, lotteryName, from, to) => {
  trackLottoEvent('lottery_draw_history_opened', {
    lottery_id: lotteryId,
    country,
    lottery_name: lotteryName,
    from,
    to,
  });

  const assistantMessage = createAssistantMessage(
    '',
    makeA2UIMessage('lottery_draw_history', {
      lottery_id: lotteryId,
      country,
      lottery_name: lotteryName,
      from,
      to,
    })
  );
  appendMessage(assistantMessage);
};
